var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#B2C5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EEF0FF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.75 19.7734H32.3875C31.2367 19.7734 30.1117 20.1039 29.1437 20.7273L28 21.4609L26.8563 20.7273C25.8892 20.104 24.763 19.7728 23.6125 19.7734H18.25C17.8352 19.7734 17.5 20.1086 17.5 20.5234V33.8359C17.5 34.2508 17.8352 34.5859 18.25 34.5859H23.6125C24.7633 34.5859 25.8883 34.9164 26.8563 35.5398L27.8969 36.2102C27.9273 36.2289 27.9625 36.2406 27.9977 36.2406C28.0328 36.2406 28.068 36.2313 28.0984 36.2102L29.1391 35.5398C30.1094 34.9164 31.2367 34.5859 32.3875 34.5859H37.75C38.1648 34.5859 38.5 34.2508 38.5 33.8359V20.5234C38.5 20.1086 38.1648 19.7734 37.75 19.7734ZM23.6125 32.8984H19.1875V21.4609H23.6125C24.4422 21.4609 25.2484 21.6977 25.9445 22.1453L27.0883 22.8789L27.25 22.9844V33.8125C26.1344 33.2125 24.8875 32.8984 23.6125 32.8984ZM36.8125 32.8984H32.3875C31.1125 32.8984 29.8656 33.2125 28.75 33.8125V22.9844L28.9117 22.8789L30.0555 22.1453C30.7516 21.6977 31.5578 21.4609 32.3875 21.4609H36.8125V32.8984ZM25.3023 24.4609H20.9477C20.8563 24.4609 20.7812 24.5406 20.7812 24.6367V25.6914C20.7812 25.7875 20.8563 25.8672 20.9477 25.8672H25.3C25.3914 25.8672 25.4664 25.7875 25.4664 25.6914V24.6367C25.4688 24.5406 25.3937 24.4609 25.3023 24.4609ZM30.5312 24.6367V25.6914C30.5312 25.7875 30.6062 25.8672 30.6977 25.8672H35.05C35.1414 25.8672 35.2164 25.7875 35.2164 25.6914V24.6367C35.2164 24.5406 35.1414 24.4609 35.05 24.4609H30.6977C30.6062 24.4609 30.5312 24.5406 30.5312 24.6367ZM25.3023 27.7422H20.9477C20.8563 27.7422 20.7812 27.8219 20.7812 27.918V28.9727C20.7812 29.0688 20.8563 29.1484 20.9477 29.1484H25.3C25.3914 29.1484 25.4664 29.0688 25.4664 28.9727V27.918C25.4688 27.8219 25.3937 27.7422 25.3023 27.7422ZM35.0523 27.7422H30.6977C30.6062 27.7422 30.5312 27.8219 30.5312 27.918V28.9727C30.5312 29.0688 30.6062 29.1484 30.6977 29.1484H35.05C35.1414 29.1484 35.2164 29.0688 35.2164 28.9727V27.918C35.2188 27.8219 35.1438 27.7422 35.0523 27.7422Z",
    fill: "#0C56D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBible);
export default __webpack_public_path__ + "static/media/bible.73a91ca921f8b5df3724000d362ea642.svg";
export { ForwardRef as ReactComponent };